import cx                   from 'classnames';
import React, { PropTypes } from 'react';
import Reflux        from 'reflux';
import TapForSoundStore from 'stores/tap-for-sound-store';
import VideoActions from 'actions/video_actions';

export default React.createClass({
  displayName: 'Player.TapSound',
  mixins: [ Reflux.connect(TapForSoundStore) ],
  shouldComponentUpdate(nextProps,nextState){
    return nextState.isVisible != this.state.isVisible;
  },
  unmute(e) {
    VideoActions.unmute();
  },
  render() {
    if (this.state.isVisible == false) {
        return null;
    }
    const classNames = cx({
      'tap-for-sound': true
    });
    return (
      <div className='tap-for-sound-layer' onClick={this.unmute}>
        <span className={classNames}></span>
      </div>
      )
  }
});



// WEBPACK FOOTER //
// ./modules/components/player/tap_sound.jsx